/* Dialog CSS Module */

/** Main dialog */
.dialog {
  --vapor-dialog-ease: cubic-bezier(0.2, 0.4, 0.1, 1);
  background: var(--colors-components-modal-background);
  border: 1px solid var(--colors-border-primary);
  border-radius: var(--radii-8);
  outline: none;
  pointer-events: auto;
  width: 100%;
  will-change: transform;

  @media screen and (min-width: 768px) {
    max-width: var(--vapor-dialog-width);
  }

  /* Animations */
  opacity: 1;
  transform: scale(1);
  transition: transform 250ms var(--vapor-dialog-ease), opacity 250ms var(--vapor-dialog-ease);

  &:where([data-entering], [data-exiting]) {
    opacity: 0;
    transform: scale(0.96);
  }

  &:where([data-exiting]) {
    transition-duration: 150ms;
  }

  &:where([data-disable-animation]) {
    transition: none;
  }

  @media (prefers-reduced-motion: reduce) {
    &:where([data-entering], [data-exiting]) {
      transform: scale(1);
    }
  }

  /* Fullscreen size */
  &:where([data-size='fullscreen']) {
    height: 100%;
    background: var(--colors-background-base);
  }

  /* Mobile fullscreen variant */
  &:where([data-mobile-fullscreen]) {
    @media (max-width: 767px) {
      border: none;
      border-radius: 0;
      height: 100dvh;
      max-height: 100dvh;
      width: 100%;
    }
  }
}

/** Overlay */
.overlay {
  --vapor-dialog-ease: cubic-bezier(0.2, 0.4, 0.1, 1);
  background: var(--colors-components-modal-overlay-background);
  inset: 0;
  opacity: 1;
  position: fixed;
  transition: opacity 250ms var(--vapor-dialog-ease);

  &:where([data-entering], [data-exiting]) {
    opacity: 0;
  }

  &:where([data-exiting]) {
    transition-duration: 150ms;
  }
}

/** DialogHeader */
.headerContainer {
  display: grid;
  gap: var(--spaces-24);
  grid-template-columns: 1fr auto;
  padding: var(--spaces-16);

  &:where([data-show-border]) {
    border-bottom: 1px solid var(--colors-border-primary);
  }
}

/** DialogFooter */
.footer {
  display: flex;
  padding: var(--spaces-16);

  &:where([data-show-border]) {
    border-top: 1px solid var(--colors-border-primary);
  }
}

/** DialogActions */
.actions {
  margin-left: auto;
}
